import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#oem-finanace-calc-app', App);
